import { VIDEO_LAYOUT_IDS, normalizeVideoLayoutId } from '../layouts'

function normalizeEnumValue(value, allowedValues, fallbackValue) {
  return allowedValues.includes(value) ? value : fallbackValue
}

export const LAYOUT_MODES = Object.freeze({
  ...VIDEO_LAYOUT_IDS,
})

export const SURFACE_POLICY_IDS = Object.freeze({
  mentorChamber: 'mentor-chamber',
  kioskScreen: 'kiosk-screen',
  standardLive: 'standard-live',
  publicLive: 'public-live',
  auditObserver: 'audit-observer',
  supportAuditObserver: 'support-audit-observer',
})

/**
 * Backend contract alias used to choose the shared presentation policy.
 * In the first reboot wave this intentionally matches the surface policy ids.
 */
export const SESSION_INTERFACE_IDS = Object.freeze({
  ...SURFACE_POLICY_IDS,
})

/**
 * @param {string | null | undefined} layoutMode
 * @param {string} [fallbackValue=LAYOUT_MODES.stageOverlay]
 * @returns {string}
 */
export function normalizeLayoutMode(
  layoutMode,
  fallbackValue = LAYOUT_MODES.stageOverlay,
) {
  return normalizeVideoLayoutId(layoutMode, fallbackValue)
}

/**
 * @param {string | null | undefined} surfacePolicyId
 * @param {string} [fallbackValue=SURFACE_POLICY_IDS.standardLive]
 * @returns {string}
 */
export function normalizeSurfacePolicyId(
  surfacePolicyId,
  fallbackValue = SURFACE_POLICY_IDS.standardLive,
) {
  return normalizeEnumValue(
    surfacePolicyId,
    Object.values(SURFACE_POLICY_IDS),
    fallbackValue,
  )
}

/**
 * @param {string | null | undefined} sessionInterfaceId
 * @param {string} [fallbackValue=SESSION_INTERFACE_IDS.standardLive]
 * @returns {string}
 */
export function normalizeSessionInterfaceId(
  sessionInterfaceId,
  fallbackValue = SESSION_INTERFACE_IDS.standardLive,
) {
  return normalizeEnumValue(
    sessionInterfaceId,
    Object.values(SESSION_INTERFACE_IDS),
    fallbackValue,
  )
}
